import { RSAA } from 'redux-api-middleware'
import {
  getApiPath,
  makeQueryParams,
  webStorage,
} from 'sidecar-utility-library'

import { initialState, types } from 'store/Doctor'

/**
 * Action creator to fetch recently viewed doctors for the current member
 *
 * @param {number} [size=25] - Number of recently viewed doctors to fetch.
 *   Default is `25`
 * @returns {Object} Redux API Middleware action to fetch recently viewed
 *   doctors
 */

export const fetchRecentlyViewed = size => ({
  [RSAA]: {
    endpoint: getApiPath(
      `doc`,
      `views/doctors${makeQueryParams({
        page: 0,
        size: size || 25,
        memberUuid: webStorage.getItem('sub'),
      })}`,
      'v2',
    ),
    method: 'GET',
    types: [
      types.FETCH_RECENTLY_VIEWED_REQUEST,
      types.FETCH_RECENTLY_VIEWED_SUCCESS,
      types.FETCH_RECENTLY_VIEWED_ERROR,
    ],
  },
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_RECENTLY_VIEWED_REQUEST: {
      return {
        ...state,
        recentlyViewed: {
          ...state.recentlyViewed,
          busy: true,
          error: '',
        },
      }
    }
    case types.FETCH_RECENTLY_VIEWED_SUCCESS: {
      const { content = [] } = payload
      return {
        ...state,
        recentlyViewed: {
          ...state.recentlyViewed,
          busy: false,
          entities: content,
        },
      }
    }
    case types.FETCH_RECENTLY_VIEWEDNS_ERROR: {
      return {
        ...state,
        recentlyViewed: {
          ...state.recentlyViewed,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    // ----------

    default:
      return state
  }
}
